import api from '../..'

const requests = {
    create: async ({ firstName, lastName, username }) => {
        var response = await api.post(`/maarima/Patient`, {
            firstName,
            lastName,
            username
        })

        return response.data
    },
    update: async ({ id, firstName, lastName, username, active }) => {
        var response = await api.put(`/maarima/Patient/${id}`, {
            firstName,
            lastName,
            username,
            active
        })

        return response.data
    }
}

export default requests
